import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6b35f984"
import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./App.vue?vue&type=style&index=0&id=6b35f984&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=6b35f984&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports